import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface ApiResponse<T> {
  value: T;
}
interface QueryPagoFacturaWeb {
  oidLiquidacion: number;
  rut: string | undefined;
}

interface IResponseFacturaWeb {
  ok: boolean;
  mensaje: string | null;
}

export const pagoFacturaWeb = async (
  query: QueryPagoFacturaWeb
): Promise<IResponseFacturaWeb> => {
  try {
    const res = await apiClient.post<ApiResponse<IResponseFacturaWeb>>(
      Endpoints.PagoFacturarWeb,
      {
        oidLiquidacion: query.oidLiquidacion,
        rut: query.rut,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
